import { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { SnapLineMode } from "mapbox-gl-draw-snap-mode";

import { handleSnapMouseMove } from "./helper";
import { DEFAULT_SNAP_PREVIEW_STYLE, ensurePreviewCircleLayer, removePreviewLayer } from "./snapPreview";

const SNAP_PREVIEW_SOURCE_ID = "snap-line-preview-source";
const SNAP_PREVIEW_LAYER_ID = "snap-line-preview-layer";

/**
 * Custom SnapLineMode that uses snapWithPointPriority to prioritize
 * snapping to Points over LineStrings/Polygons, and shows a visual
 * preview when snapping occurs.
 */
const CustomSnapLineMode: DrawCustomMode = {
  ...SnapLineMode,

  onSetup: function (opts) {
    const state = SnapLineMode.onSetup?.call(this, opts) ?? {};

    // Setup snap preview layer
    ensurePreviewCircleLayer(this.map, SNAP_PREVIEW_SOURCE_ID, SNAP_PREVIEW_LAYER_ID, DEFAULT_SNAP_PREVIEW_STYLE);

    return state;
  },

  onMouseMove: function (state, e) {
    return handleSnapMouseMove(this, SnapLineMode, state, e, SNAP_PREVIEW_SOURCE_ID);
  },

  onStop: function (state) {
    // Clean up the snap preview layer
    removePreviewLayer(this.map, SNAP_PREVIEW_SOURCE_ID, SNAP_PREVIEW_LAYER_ID);

    // Call parent onStop if it exists
    if (SnapLineMode.onStop) {
      return SnapLineMode.onStop.call(this, state);
    }
  },
};

export default CustomSnapLineMode;
